import {inject, injectable} from "inversify";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
// @ts-ignore
import Preloader from 'assets-preloader';
import {Application} from "@/di";

@injectable()
export default class AssetLoader {
  constructor(
    @inject(Application) private app: Application,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  async load(assetUrls: string[], onProgress?: (progress: number) => void) {
    const loader = new Preloader(assetUrls);

    loader.listen('progress', onProgress);

    await loader.load();
  }

  async loadApp(onProgress?: (progress: number) => void) {
    await this.load(
      collect(this.app.modules.map(m => m.assets))
        .flatten(1)
        .toArray(),
      onProgress,
    );
  }
}
